import { useState } from "react";
import { Divider, IconButton } from "rsuite";
import SioIcon from "../../../icon/rsuite-icon-font/SioIcon";

export const Foldable = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <>
      {isExpanded && children}
      <Divider className="col-xs-12 foldable-divider">
        <IconButton
          icon={<SioIcon rotate={90 * (isExpanded ? 1 : -1)} icon="left" />}
          onClick={() => setIsExpanded((v) => !v)}
          color="blue"
          size="sm"
        />
      </Divider>
    </>
  );
};
